
import FAQ from "./components/FAQ";
import FeaturesGrid from "./components/FeaturesGrid";
import Footer from "./components/Footer";
import Hero from "./components/Hero";
import UseCases from "./components/UseCases";
import { faqs, footerNavigation } from "./contentSections";

export default function LandingPage() {
  return (
    <div className="bg-background text-foreground landing-page">
      <main className="isolate">
        <Hero />
        <UseCases />
        <FeaturesGrid />
        <FAQ faqs={faqs} />

      </main>
      <Footer footerNavigation={footerNavigation} />
    </div>
  );
}
